import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ModalBannerConstants from '../../../../constants/ModalBannerConstants';
import AnnouncementWalkthroughSettings from '../../../../constants/AnnouncementWalkthroughSettings';
import cameraIcon from '../../../../assets/images/photo-circle-blue.svg';

import CircleAnnouncementWalkthrough from '../CircleAnnouncementWalkthrough';

import './DelaysAnnouncementCircleMultiple.scss';

/**
 * DelaysAnnouncementCircleMultiple is a <CircleGlobalModal> which is used to display an initial
 * fullscreen push notifications announcement/overlay to the user. Users should only see this once.
 */
export class DelaysAnnouncementCircleMultiple extends Component {

  constructor(props) {

    DelaysAnnouncementCircleMultiple.propTypes = {
    };

    super(props);
    this.state = {
      status: null,
    };

    this.handleOnClose = this.handleOnClose.bind(this);
    this.handleLastOnClose = this.handleLastOnClose.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  handleOnClose() {
    this.setState({ closeChildren: true });
  }

  handleLastOnClose() {
    this.props.onClose();
  }

  render() {
    
    let doneSettings = _.cloneDeep(AnnouncementWalkthroughSettings.DelayDetailsDoneAnnouncement);
    const doneInternalElement = <div className="announcement-highlight">
      <div className='mock-delay-button'>SUBMIT DELAY</div>
    </div>;
    doneSettings.highlightSettings.internalElement = doneInternalElement;

    let documentSettings = _.cloneDeep(AnnouncementWalkthroughSettings.DelayDetailsDocumentAnnouncement);
    const documentInternalElement = <div className="announcement-highlight">
      <img className='highlight-img'
        src={cameraIcon}
        alt='upload'
      />
    </div>;
    documentSettings.highlightSettings.internalElement = documentInternalElement;

    return (
      <div className="delays-announcement-circle-multiple">
        <CircleAnnouncementWalkthrough modalType={ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT + '_delay_details_done'}
          modalProps={{
            userSetting: 'user_has__viewed_mobile_delays_announcement_delay_details_done',
            announcementSettings: doneSettings,
          }} onClose={this.handleOnClose} dontCloseOnCollapse={true} />
        <CircleAnnouncementWalkthrough modalType={ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT + '_delay_details_document'}
          modalProps={{
            userSetting: 'user_has__viewed_mobile_delays_announcement_delay_details_document',
            announcementSettings: documentSettings, 
          }} onClose={this.handleLastOnClose} closeDisplay={this.state.closeChildren} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(DelaysAnnouncementCircleMultiple);



// WEBPACK FOOTER //
// ./src/components/modals/CircleAnnouncement/DelaysAnnouncementCircleMultiple/index.js